import {
  Divider,
  Image,
  Navbar as NavigationBar,
  NavbarContent,
} from '@nextui-org/react';
import React, { FC } from 'react';
import Logo from '../../assets/logosomerlog.png';
import LogoSmall from '../../assets/somer-vector.png';
import ThemeSwitch from '../ThemeSwitch/ThemeSwitch';
import ToggleMenuButton from '../ToggleMenuButton/ToggleMenuButton';

interface NavbarProps {
  onMenuToggle: (isOpen: boolean) => void;
  isMobile?: boolean;
}

const Navbar: FC<NavbarProps> = ({
  onMenuToggle,
  isMobile = false,
}): JSX.Element => {
  return (
    <NavigationBar
      classNames={{
        wrapper: ['max-w-none', 'content-between', `bg-foreground-50`],
      }}
    >
      <NavbarContent className={`ml-[-12px] ${!isMobile ? 'gap-4' : 'gap-1'} `}>
        {/* Menu Toggle */}
        <ToggleMenuButton onMenuToggle={onMenuToggle} />

        {/* Logo  */}
        {!isMobile && (
          <div className="rounded-md bg-foreground-500 px-3 py-1">
            <Image
              width={200}
              className="rounded-none"
              alt="Company Logo"
              src={Logo}
            />
          </div>
        )}
        {!isMobile && (
          <Divider orientation="vertical" className="h-8 w-[2px]" />
        )}
        {/* App Title */}
        {!isMobile && (
          <h3 className="whitespace-nowrap font-bold text-foreground-800 ">
            Sistema Etiquetador
          </h3>
        )}
      </NavbarContent>
      {isMobile && (
        <NavbarContent justify="center">
          {/* Logo  */}
          <Image
            width={50}
            className="rounded-none"
            alt="Company Logo 2"
            src={LogoSmall}
          />
        </NavbarContent>
      )}
      <NavbarContent justify="end">
        {/* Theme Switcher */}
        <ThemeSwitch isMobile={isMobile} />
      </NavbarContent>
    </NavigationBar>
  );
};

export default Navbar;
